import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import { tiposFormaPagamentoDisplay } from "data/formasPagamento";
import Badge from "components/base/Badge";

// Definição do tipo para a tabela de formas de pagamento
export interface FormaPagamentoTableType {
    id: string;
    codigo: number;
    descricao: string;
    tipo: string;
    contaDestinoId?: string;
    contaDestinoNome?: string;
    isDeleted: boolean;
    createdAt: string;
    updatedAt: string;
    prazos: PrazoAssociadoType[];
}

export interface PrazoAssociadoType {
    id: string;
    descricao: string;
    parcela: number;
    isDeleted: boolean;
}

// Definição das colunas da tabela
export const formaPagamentoTableColumns: ColumnDef<FormaPagamentoTableType>[] = [
    {
        accessorKey: "codigo",
        header: "Código",
        cell: ({ getValue }) => (
            <span className="text-body-emphasis">
                #{getValue<number>()}
            </span>
        ),
        size: 80,
    },
    {
        accessorKey: "descricao",
        header: "Descrição",
        cell: ({ row: { original } }) => {
            const { descricao, id } = original;
            return (
                <Link
                    to={`/cadastros/formas-pagamento/${id}`}
                    className="fw-semibold line-clamp-3"
                >
                    {descricao}
                </Link>
            );
        },
        meta: {
            headerProps: { style: { width: 350 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    },
    {
        accessorKey: "tipo",
        header: "Tipo",
        cell: ({ getValue }) => (
            <Badge variant="tag">
                {tiposFormaPagamentoDisplay[getValue<string>()] || getValue<string>()}
            </Badge>
        ),
        size: 150,
    },
    {
        accessorKey: "contaDestinoNome",
        header: "Conta Destino",
        cell: ({ getValue }) => {
            const conta = getValue<string>();
            return conta ? (
                <span className="text-body-emphasis">{conta}</span>
            ) : (
                <span className="text-body-secondary fst-italic">Não vinculada</span>
            );
        },
        size: 150,
    },
    {
        accessorKey: "isDeleted",
        header: "Status",
        cell: ({ getValue }) => (
            <Badge bg={getValue<boolean>() ? "danger" : "success"} className="badge-subtle rounded-pill">
                {getValue<boolean>() ? "Inativa" : "Ativa"}
            </Badge>
        ),
        size: 100,
    },
    {
        accessorKey: "prazos",
        header: "Prazos",
        cell: ({ getValue }) => {
            const prazos = getValue<PrazoAssociadoType[]>();
            if (!prazos || prazos.length === 0) {
                return <span className="text-body-secondary fst-italic">Nenhum prazo</span>;
            }

            const prazosAtivos = prazos.filter(p => !p.isDeleted);
            const prazosCount = prazosAtivos.length;

            return (
                <div className="d-flex align-items-center gap-1">
                    <Badge text="dark" className="border">
                        {prazosCount} prazo{prazosCount !== 1 ? 's' : ''}
                    </Badge>
                    {prazosCount > 0 && (
                        <span className="text-body-secondary small">
                            ({prazosAtivos.map(p => `${p.parcela}x`).join(', ')})
                        </span>
                    )}
                </div>
            );
        },
        size: 150,
    },
    {
        accessorKey: "createdAt",
        header: "Criada em",
        cell: ({ getValue }) => (
            <span className="text-body-secondary">
                {new Date(getValue<string>()).toLocaleDateString("pt-BR")}
            </span>
        ),
        size: 120,
    },

];

const FormaPagamentoTable = () => {
    return (
        <div>
            <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
            <AdvanceTableFooter pagination showViewAllBtn={false} />
        </div>
    );
};

export default FormaPagamentoTable; 